import { Hidden } from '@material-ui/core'
import { Link } from 'react-router-dom'
import step1 from '../../Assets/layout_images/step1.png'
import step2 from '../../Assets/layout_images/step2.png'
import step3 from '../../Assets/layout_images/step3.png'
import step5 from '../../Assets/layout_images/step5.png'
import step6 from '../../Assets/layout_images/step6.png'
import step7 from '../../Assets/layout_images/step7.png'

export default function Steps({ type, color }) {
    const points = [
        {
            title: 'Tutor Selection',
            content: 'Students choose a tutor that fits their learning style. Focused on pace, basics & teaching style.',
            image: step1,
            backgroud: '#e9f3ff',
        },
        {
            title: 'Personalized Timetable',
            content: 'Custom timetable based on school, meals, and personal activities.',
            image: step2,
            backgroud: '#f2f8ff',
        },
        {
            title: 'Session Management',
            content: 'Need to reschedule? In emergency situations, timings can be adjusted.',
            image: step3,
            backgroud: '#edf6ff',
        },
        {
            title: 'Hybrid AI Exams',
            content: 'Tests every 15 days via our AI tool. Assessing subject knowledge and improvement in 3 levels.',
            image: step7,
            backgroud: '#e6f2ff',
        },
        {
            title: 'Real-Time Progress Tracking',
            content: 'Parents can track growth and performance anytime.',
            image: step5,
            backgroud: '#f0f7ff',
        },
        {
            title: 'Monthly Growth Sessions',
            content: 'Monthly sessions for academic and emotional guidance.',
            image: step6,
            backgroud: '#ebf5ff',
        },
    ]

    function makesteps() {
        return (
            <>
                {points.map((el, key) => (
                    <div
                        className="steps"
                        key={key}
                        style={{ backgroundColor: el.backgroud }}
                    >
                        <div className="steps-content">
                            <div>
                                <h2 className="font-Quick font-semi">{el.title}</h2>
                                <p className="font-Quick font-med step-content-text">
                                    {el.content}
                                </p>
                                <div className={`get_started_button_${type}`}>
                                    <Link
                                        className={`${type}_book_button font-Quick font-bold`}
                                        to="/form"
                                    >
                                        Book Now
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div
                            className="steps-image"
                            style={{
                                backgroundImage: `url(${el.image})`,
                                backgroundSize: 'contain',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}
                        >
                            <div
                                className="image-overlay"
                                style={{
                                    background: `linear-gradient(90deg, ${el.backgroud}, transparent)`,
                                }}
                            ></div>
                        </div>
                    </div>
                ))}
            </>
        )
    }

    return (
        <div className={`${type}_how_to_get_started_section how_to_get_started_section`}>
            <h2 className="font-Quick font-semi">How It Works?</h2>
            <p className="font-Quick font-med">
                We Help Your Child Earn Better Marks In 6 Steps
            </p>
            <Hidden mdUp>
                <div
                    className={`${type}_how_to_get_started_section_mob how_to_get_started_section_mob`}
                >
                    <div>{makesteps()}</div>
                </div>
            </Hidden>
            <Hidden smDown>
                <div
                    className={`${type}_how_to_get_started_section_desk how_to_get_started_section_desk`}
                >
                    <div>{makesteps()}</div>
                </div>
            </Hidden>
        </div>
    )
}
